import { SYS_OPACITY_0_PCT, SYS_OPACITY_100_PCT, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_XL, SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_MD, SYS_PAGE_MARGIN_XS, SYS_BORDER_RADIUS_MD, SYS_BORDER_WIDTH_100, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200, SYS_BREAKPOINT_SM, SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_600, SYS_SPACE_FIXED_700, SYS_SPACE_FIXED_800, SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-alpha-common';
import styled, { css } from 'styled-components';
import { IconButton } from '../icon-button/index.js';
export const StyledChildrenContainer = styled.div ``;
export const StyledInner = styled.div `
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    position: relative;
  }
`;
export const StyledDialog = styled.dialog `
  @keyframes show {
    from {
      opacity: ${SYS_OPACITY_0_PCT};
      transform: translateY(40px);
    }
    to {
      opacity: ${SYS_OPACITY_100_PCT};
      transform: translateY(0);
    }
  }

  box-sizing: border-box;
  background: ${(props) => props.theme.sys.gradient.elevation.level1.fill};
  border-radius: ${SYS_BORDER_RADIUS_MD} ${SYS_BORDER_RADIUS_MD} 0 0;
  ${(props) => css `
    box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
      ${props.theme.sys.color.elevation.level1.stroke};
  `}
  border: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  inset-block-start: auto;

  &[open] {
    // TODO: Tokens missing
    animation: show 0.42s ease forwards;
  }

  &::backdrop {
    background-color: ${(props) => props.theme.sem.color.ui.surface.scrim.default};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    inset-block-start: revert;
    border-radius: none;

    ${(props) => props.variant !== 'alert'
    ? css `
            border-radius: 0 0 0 0;
          `
    : css `
            border-radius: ${SYS_BORDER_RADIUS_MD};
          `}

    ${(props) => props.variant === 'alert' &&
    css `
        width: 600px;
      `}
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: ${(props) => props.variant === 'alert'
    ? '600px'
    : props.variant === 'focus-small'
        ? SYS_BREAKPOINT_MD
        : SYS_BREAKPOINT_LG};

    border-radius: ${SYS_BORDER_RADIUS_MD};
  }

  ${StyledInner} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: block;
    }

    ${StyledChildrenContainer} {
      width: 100%;
      box-sizing: border-box;

      ${(props) => props.hasPadding &&
    css `
          padding: 0 ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_200}
            ${SYS_SPACE_FIXED_200};

          @media (min-width: ${SYS_BREAKPOINT_SM}) {
            padding: 0 ${SYS_SPACE_FIXED_350} ${SYS_SPACE_FIXED_350}
              ${SYS_SPACE_FIXED_350};
          }

          @media (min-width: ${SYS_BREAKPOINT_MD}) {
            padding: ${SYS_SPACE_FIXED_600};
          }

          @media (min-width: ${SYS_BREAKPOINT_LG}) {
            padding: ${SYS_SPACE_FIXED_700};
          }

          @media (min-width: ${SYS_BREAKPOINT_XL}) {
            padding: ${SYS_SPACE_FIXED_800};
          }
        `}
    }
  }
`;
export const StyledIconButton = styled(IconButton) `
  padding: ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_50};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: 0;
    position: absolute;
    top: ${SYS_SPACE_FIXED_100};
    right: ${SYS_SPACE_FIXED_100};
  }
`;
export const StyledAlert = styled.div `
  padding: ${SYS_PAGE_MARGIN_XS};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: ${SYS_PAGE_MARGIN_MD};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    padding: ${SYS_PAGE_MARGIN_LG};
  }
`;
//# sourceMappingURL=index.styles.js.map